import React, { useCallback } from "react";

import classNames from "classnames";

import { useDispatch } from "react-redux";
import { closeCart } from "@store/cart";
import { navigate } from "gatsby";

import CartItemProperty from "@components/widgets/cart/item/property/CartItemProperty";
import CartItemFooter from "@components/widgets/cart/item/footer/CartItemFooter";
import CartItemHeader from "@components/widgets/cart/item/title/CartItemHeader";
import CartItemImg from "@components/widgets/cart/item/img/CartItemImg";

import type { Product } from "@typings/product/product";
import type { CartItemType } from "@typings/cart";

interface CartItemProps {
  cartItem: Product;

  className?: string;

  type?: CartItemType;

  hideRemoveBtn?: boolean;
  hideCounter?: boolean;
  isTopDeal?: boolean;
}

const CartItem = ({
  cartItem,
  className,
  type = "EDIT",
  hideRemoveBtn,
  hideCounter,
  isTopDeal,
}: CartItemProps) => {
  const { item, configuration } = cartItem;

  const dispatch = useDispatch();

  const redirectToProductPage = useCallback(() => {
    if (item.price === 0) return;

    void navigate(`/shop/${item.information?.slug}`);

    dispatch(closeCart());
  }, [dispatch, item]);

  return (
    <React.Fragment>
      <div className={classNames("cart-item", className, { "cursor-default": item.price === 0 })}>
        <CartItemImg item={item} redirectToProductPage={redirectToProductPage} />

        <div className="cart-item__info">
          <CartItemHeader cartItem={cartItem} redirectToProductPage={redirectToProductPage} />

          <CartItemProperty name={configuration.offer.title} productType={item.category.name} />

          <CartItemFooter
            cartItem={cartItem}
            type={type}
            hideRemoveBtn={hideRemoveBtn}
            hideCounter={hideCounter}
            isTopDeal={isTopDeal}
          />
        </div>
      </div>

      <hr className="cart-item__separator" />
    </React.Fragment>
  );
};

export default CartItem;
